import { render, staticRenderFns } from "./TextEllipsis.vue?vue&type=template&id=3ec515d2&scoped=true&"
import script from "./TextEllipsis.vue?vue&type=script&lang=js&"
export * from "./TextEllipsis.vue?vue&type=script&lang=js&"
import style0 from "./TextEllipsis.vue?vue&type=style&index=0&id=3ec515d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec515d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
